module.exports = __webpack_public_path__ + "img/published-modal-image-premium.e4a1a079.png";